import { RFP_STATE } from '../constants'

export const isAwardable = (state: string | undefined | null) =>
  state === RFP_STATE.PUBLISHED || state === RFP_STATE.CLOSED
